/**
 * Coming Soon route configuration
 *
 * Add any app path here to show the Coming Soon page instead of the real feature.
 * Remove a path (or comment it out) to restore normal behaviour — no other code changes needed.
 *
 * Path formats:
 * - Exact:     '/workflows'
 * - Prefix:    '/prompts/*'                          → /prompts and /prompts/:folderId
 * - Dynamic:   '/agent-details/:agentId'              → /agent-details/{uuid} only
 * - Dynamic:   '/agent-details/:agentId/configuration' → that tab only
 * - Dynamic:   '/agent-details/:agentId/*'             → all tabs under an agent (configuration, integrations, …)
 *
 * Param names (:agentId, :id, etc.) are labels only — any non-empty segment matches.
 *
 * @example
 * // Only block the Configuration tab for every agent:
 * comingSoonRoutes: ['/agent-details/:agentId/configuration']
 *
 * @example
 * // Block the whole agent-details area (all tabs):
 * comingSoonRoutes: ['/agent-details/:agentId/*']
 */

/** Set to false to disable all coming-soon restrictions (listed routes work normally). */
export const COMING_SOON_ENABLED = true;

/**
 * Routes that should render the Coming Soon page while listed.
 * Use the same path strings as in App.tsx / sidebar navigation.
 */
export const comingSoonRoutes: string[] = [
  // '/workflows',
  // '/prompts/*',
  //
  // '/agents',
  // '/agent-details/:agentId/configuration',  // only Configuration tab
  // '/agent-details/:agentId/integrations',   // only Integrations tab
  // '/agent-details/:agentId',                // agent overview only (no tab path)
  // '/agent-details/:agentId/*',              // every tab under any agent id

  
];
